import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import UserProfile from 'app/modules/auth/components/profile/UserProfile'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import TopBarProgress from 'react-topbar-progress-indicator'

const PrivateRoutes = () => {
  const SystemRoutes = lazy(() => import('app/modules/system/SystemRoutes'))
  const DuaRoutes = lazy(() => import('app/modules/dua/DuaRoutes'))
  const DphsRoutes = lazy(() => import('app/modules/dphs/DphsRoutes'))
  const CanteenRoutes = lazy(() => import('app/modules/canteen/CanteenRoutes'))
  const LecturerRoutes = lazy(() => import('app/modules/dua/Lecturer/LecturerRoutes'))
  const StudentRoutes = lazy(() => import('app/modules/dua/Student-Portal/StudentRoutes'))
  const SchoolLecturerRoutes = lazy(() => import('app/modules/dphs/Lecturer/SchoolLecturerRoutes'))
  const SchoolStudentRoutes = lazy(
    () => import('app/modules/dphs/Student-Portal/SchoolStudentRoutes')
  )
  const ChatRoutes = lazy(() => import('app/modules/chat/ChatRoutes'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registration */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Dashboard */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='/profile' element={<UserProfile />} />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
        <Route
          path='system-mgt/*'
          element={
            <SuspensedView>
              <SystemRoutes />
            </SuspensedView>
          }
        />
        <Route
          path='dua/*'
          element={
            <SuspensedView>
              <DuaRoutes />
            </SuspensedView>
          }
        />
        <Route
          path='canteen/*'
          element={
            <SuspensedView>
              <CanteenRoutes />
            </SuspensedView>
          }
        />
        <Route
          path='lecturer/*'
          element={
            <SuspensedView>
              <LecturerRoutes />
            </SuspensedView>
          }
        />
        <Route
          path='student/*'
          element={
            <SuspensedView>
              <StudentRoutes />
            </SuspensedView>
          }
        />
        // Dphs
        <Route
          path='dphs/*'
          element={
            <SuspensedView>
              <DphsRoutes />
            </SuspensedView>
          }
        />
        <Route
          path='dphs/lecturer/*'
          element={
            <SuspensedView>
              <SchoolLecturerRoutes />
            </SuspensedView>
          }
        />
        <Route
          path='dphs/student/*'
          element={
            <SuspensedView>
              <SchoolStudentRoutes />
            </SuspensedView>
          }
        />
        <Route
          path='chat/*'
          element={
            <SuspensedView>
              <ChatRoutes />
            </SuspensedView>
          }
        />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
